// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zZDV7bQaxwHeOeSs2dd8 > tbody > tr > td {
    vertical-align: middle;
    border-top: none;
}

.zZDV7bQaxwHeOeSs2dd8 > tbody > tr.FXIUuU5VLj0IMNMvfNDS > td {
    border-top: 1px solid #ccc;
}

.LlPfjLAvrSDekpnmBkwd {
    text-align: center;
    line-height: 2;
    font-size: 14px;
    padding: 16px 0;
}

.GZMiXT8Q5ksold55CEbf {
    font-size: 32px;
    color: rgb(190, 190, 190);
}

.iRsDuJzOtTBhB7pAsmp2 {
    font-size: 12px;
}

.vGDqdOaJBXCLN3uFtANC {
    line-height: 1.5;
}

.Vm9DvKD5tBkSqxHLKUnt {
    margin-top: 16px;
    text-align: right;
}

.Vm9DvKD5tBkSqxHLKUnt > button + button {
    margin-left: 8px;
}

.lD3zkahJQ7WbdWuzdDma {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.lD3zkahJQ7WbdWuzdDma > a {
    cursor: pointer;
}

.lD3zkahJQ7WbdWuzdDma > a + a {
    margin-left: 8px;
}

.gQ9zF_gvVk8Ra3Wfq2SN {
    text-decoration: none !important;
    font-size: 22.5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-documents/components/documents.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB","sourcesContent":[".table > tbody > tr > td {\n    vertical-align: middle;\n    border-top: none;\n}\n\n.table > tbody > tr.divider > td {\n    border-top: 1px solid #ccc;\n}\n\n.empty {\n    text-align: center;\n    line-height: 2;\n    font-size: 14px;\n    padding: 16px 0;\n}\n\n.emptyIcon {\n    font-size: 32px;\n    color: rgb(190, 190, 190);\n}\n\n.detail {\n    font-size: 12px;\n}\n\n.modal {\n    line-height: 1.5;\n}\n\n.modalButtons {\n    margin-top: 16px;\n    text-align: right;\n}\n\n.modalButtons > button + button {\n    margin-left: 8px;\n}\n\n.actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.actions > a {\n    cursor: pointer;\n}\n\n.actions > a + a {\n    margin-left: 8px;\n}\n\n.remove {\n    text-decoration: none !important;\n    font-size: 22.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `zZDV7bQaxwHeOeSs2dd8`,
	"divider": `FXIUuU5VLj0IMNMvfNDS`,
	"empty": `LlPfjLAvrSDekpnmBkwd`,
	"emptyIcon": `GZMiXT8Q5ksold55CEbf`,
	"detail": `iRsDuJzOtTBhB7pAsmp2`,
	"modal": `vGDqdOaJBXCLN3uFtANC`,
	"modalButtons": `Vm9DvKD5tBkSqxHLKUnt`,
	"actions": `lD3zkahJQ7WbdWuzdDma`,
	"remove": `gQ9zF_gvVk8Ra3Wfq2SN`
};
export default ___CSS_LOADER_EXPORT___;
